import { render, staticRenderFns } from "./Informasi.vue?vue&type=template&id=e658d9ee&"
import script from "./Informasi.vue?vue&type=script&lang=js&"
export * from "./Informasi.vue?vue&type=script&lang=js&"
import style0 from "./Informasi.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports